exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.doc-container[data-v-5ab41d4e]{\n  background: #fff;\n  border: 1px solid rgba(0,0,0,.125);\n  position: relative;\n}\n.row .doc-info[data-v-5ab41d4e]{\n  padding: 5px;\n  margin-bottom: 12px;\n}\n", ""]);

// exports
